import { urlFor } from "../client"

const AboutCard = ({ imgUrl, title, description, animation }) => {
  return (
    <article className="skill-card" {...animation}>
        <div className="skill-card__header overflow-hidden" style={{borderRadius: "1.2rem"}}>
            <img
                src={urlFor(imgUrl)}
                alt={title}
                className="skill-card__img"
                loading="eager"
            />
        </div>
        <div className="skill-card__body text-start mt-3">
            <h3>{title}</h3>
            <p>{description}</p>
        </div>
    </article>
  )
}

export default AboutCard